import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { isEligibleForACQ177ProductisedFlow } from './isEligibleForACQ177ProductisedFlow';
import { isProductisedSignupFlow } from './isProductisedSignupFlow';
export const isAssignedToGTKMExperiment = state => {
  const isAssignedToACQ177VariantA = isEligibleForACQ177ProductisedFlow(state) || getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0177, [ExperimentParameterGroup.Variant_A]);
  return isAssignedToACQ177VariantA || isProductisedSignupFlow(state);
};